module.exports = __webpack_public_path__ + "static/media/continuous-growth.720d2286.svg";